import React, { Component, Fragment } from 'react'
import { Button } from 'antd'
import { compose, withState } from 'recompose'
import { dateVal, filterCheckedColumns, numVal, timeDateFormat } from '../../../modules/Utils'
import ViewDownload from '../../../elements/ViewDownload'
import { streamUrl } from '../../../variables/index'
import Auth from '../../../modules/Authentication'
import bytes from 'bytes'
import CustomTable from '../../../elements/Table/CustomTable'
import BoolFilter from '../../../elements/Select/BoolFilter'
import BoolCell from '../../../elements/Table/Cells/BoolCell'

class List extends Component {
  auth = new Auth()

  columns = [
    {
      Header: 'ID',
      accessor: '_id',
      Cell: ({ value, original }) => (
        <a target={'_blank'} onClick={() => this.props.handleOnRowClick(original)} style={{ marginLeft: '10px' }}>
          {original._key}
        </a>
      ),
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'FileName', accessor: 'file', hideable: true, hideDefault: true },
    {
      Header: 'Time Uploaded',
      accessor: 'timestamp',
      Cell: ({ value }) => timeDateFormat(dateVal({ value }, 'value')),
    },
    { Header: 'Category', accessor: 'category' },
    { Header: 'Description', accessor: 'description' },
    {
      Header: 'Size',
      accessor: 'size',
      sortMethod: (a, b) => (Number.parseFloat(a) < Number.parseFloat(b) ? 1 : -1),
      Cell: ({ value }) => (Number.isFinite(numVal({ value }, 'value')) ? bytes(numVal({ value }, 'value')) : value),
    },
    {
      Header: 'Email',
      accessor: 'email',
      filterMethod: filterCheckedColumns,
      Filter: BoolFilter,
      Cell: BoolCell,
    },
    {
      Header: 'File',
      accessor: '_key',
      Cell: ({ value }) =>
        value && (
          <ViewDownload
            view={`${streamUrl}files/${value}?action=view&access_token=${this.auth.getAccessToken()}`}
            download={`${streamUrl}files/${value}?action=download&access_token=${this.auth.getAccessToken()}`}
          />
        ),
    },
  ]

  render() {
    const { showModal, fetch, editable, fetching, list, allowUpload } = this.props
    return (
      <Fragment>
        <CustomTable
          CreateButton={() =>
            allowUpload && (
              <Button onClick={showModal} type="primary" size={'small'} disabled={!editable} icon="file-add">
                New{' '}
              </Button>
            )
          }
          fetch={fetch}
          fetching={fetching}
          columns={this.columns}
          data={list}
        />
      </Fragment>
    )
  }
}

List.propTypes = {}
List.defaultProps = {
  allowUpload: true,
}
export default compose(withState('filterable', 'setFilterable', false))(List)
